import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

import PageSection from '../../PageSection'
import DoughnutGraph from '../../Graphs/DoughnutGraph'

import { capitalizeFirstLetter, formatStringWithUnderscore } from '../../../../helpers/common'
import { getReusableTooltipCallbackOptions } from '../helpers'

import useStyles from '../styles'

const PlacementGraphSection = ({ rawGraphData, showAdvancedMetrics, currencySymbol }) => {
  const classes = useStyles()

  const placementGraphData = useMemo(() => rawGraphData && rawGraphData.map(data => data.impressions), [rawGraphData])
  const placementGraphLabels = useMemo(
    () =>
      rawGraphData &&
      rawGraphData.map(data => `${capitalizeFirstLetter(formatStringWithUnderscore(data.breakdown))} ${data.percent}%`),
    [rawGraphData]
  )

  const tooltipCallbackOptions = useMemo(
    () =>
      getReusableTooltipCallbackOptions({
        rawGraphData,
        showAdvancedMetrics,
        currencySymbol,
        showImpressionsAsLabel: false
      }),
    [currencySymbol, rawGraphData, showAdvancedMetrics]
  )

  return (
    <PageSection className={classes.sectionContainer}>
      <div className={classes.headingContainer}>
        <div className={classes.title}>Placement</div>
      </div>
      <DoughnutGraph
        className={classes.graphWrapper}
        data={placementGraphData}
        labels={placementGraphLabels}
        tooltipCallbackOptions={tooltipCallbackOptions}
        format="integer"
      />
    </PageSection>
  )
}

PlacementGraphSection.propTypes = {
  rawGraphData: PropTypes.array.isRequired,
  showAdvancedMetrics: PropTypes.bool,
  currencySymbol: PropTypes.string
}

export default PlacementGraphSection
